// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GlasLogo_wrapper__1xhuc","logoRow":"GlasLogo_logoRow__3Se5I","logo":"GlasLogo_logo__245gW","name":"GlasLogo_name__1P1UC"};